export default function getTooltip(kodSprawozdania) {
  switch (kodSprawozdania) {
    case 'SprFinJednostkaInnaWZlotych':
    case 'SprFinJednostkaInnaWTysiacach':
      return 'Sprawozdanie finansowe dla jednostek innych niż banki, zakłady ubezpieczeń i zakłady reasekuracji'
    case 'SprFinJednostkaMalaWZlotych':
    case 'SprFinJednostkaMalaWTysiacach':
      return 'Sprawozdanie finansowe dla jednostek małych, korzystających z uproszczeń odnoszących się do sprawozdania finansowego'
    case 'SprFinJednostkaMikroWZlotych':
    case 'SprFinJednostkaMikroWTysiacach':
      return 'Sprawozdanie finansowe dla jednostek mikro'
    case 'SprFinOpWZlotych':
    case 'SprFinOpWTysiacach':
      return 'Sprawozdanie finansowe dla jednostek, o których mowa w art. 3 ust. 2 ustawy z dnia 24 kwietnia 2003 r. o działalności pożytku publicznego i o wolontariacie'
    case 'SprFinDomMaklerskiWZlotych':
    case 'SprFinDomMaklerskiWTysiacach':
      return 'Sprawozdanie finansowe dla domu maklerskiego'
    case 'SprFinSkonsolidowanaJednostkaInnaWZlotych':
    case 'SprFinSkonsolidowanaJednostkaInnaWTysiacach':
      return 'Skonsolidowane sprawozdanie finansowe dla jednostek innych niż banki, zakłady ubezpieczeń i zakłady reasekuracji'
    default:
      return null
  }
}
